import React, {Component} from 'react';
import { Elements } from 'react-stripe-elements';

import SignIn from './views/signin/SignIn';
import ResetPassword from './views/signin/ResetPassword';
import Privacy from './views/privacy/Privacy';
import {Route, Switch} from 'react-router-dom';
import Home from './views/home/Home';
import Team from './views/team/Team';
import ContactUs from './views/contactus/ContactUs';
import Affiliate from './views/affiliate/Affiliate';
import TermsOfUse from './views/termsofuse/TermsOfUse';
import FlexLayout from './views/layout/FlexLayout';
import FixedLayout from './views/layout/FixedLayout';
import OnboardingView from './views/onboarding/OnboardingContainer';
import Storeonboarding from './views/storeonboarding/Stor_OnboardingContainer';
import WelcomePage from './views/onboardingAA/WelcomePage';
import SurveyResultNew from './views/onboarding/SurveyResultNew';
import GateFee from './views/onboarding/GateFee';
import GateFeeAA from './views/AA/gateFee/GateFee';
import GateFeeBoarding from './views/onboardingAA/GateFeeBoarding';
import Recommendations from './views/recommendations/Recommendations';
import ProductDetail from './views/productdetail/ProductDetail';
import PriceMatching from './views/pricematching/PriceMatching'
import NotFound from "./views/notfound/NotFound";
import Account from './views/account/Account';
import OurStory from './views/ourstory/OurStory';
import Wishlist from "./views/wishlist/Wishlist";
import ReturnPolicy from './views/return/ReturnPolicy';
import ReviewedProducts from "./views/reviewedproducts/ReviewedProducts";
import Referral from './views/referral/Referral.js';
import Gift from './views/gift/Gift';
import GiftThankYou from './views/gift/GiftThankYou';
import Orders from './views/order/Orders';
import CustomerPortalPassword from './views/customersuccessportal/CustomerPortalPassword';
import CustomerEmail from './views/customersuccessportal/CustomerEmail';
import CustomerInfoAndProducts from './views/customersuccessportal/CustomerInfoAndProducts';
import AthLayout from './ath/layout/AthLayout';
import AthLayoutFlex from './ath/layout/AthLayoutFlex';
import AthOnboardingView from './ath/views/AthOnboardingContainer';
import AthOnboardingView_v1 from './ath/views/v1/AthOnboardingContainer';
import AthHairProfile from './ath/views/profile/AthHairProfile';
import AthRecommendations from './ath/views/recommendations/AthRecommendations';
import AthLogin from './ath/views/login/AthLogin';
import AthReset from './ath/views/reset/AthReset';
import HairBuffer from './views/hair/buffer/HairBuffer';
import HairOnboarding from './views/hair/onboarding/HairOnboardingContainer';
import HairProfile from './views/hair/profile/HairProfile';
import HairRecommendations from './views/hair/recommendations/HairRecommendations';
import ShowThankYou from './views/showThankYous/showThankYouAA';
import Blog from './views/blog/Blog';
import BlogDetail from './views/blog/BlogDetail';
import PlanView from './views/AA/plan/planView';

import {StripeProvider} from 'react-stripe-elements';
import './views/common/common.css';
import './views/common/animate.css';
// import './views/common/reset.css';


import initReactFastclick from 'react-fastclick';
initReactFastclick();


export default class App extends Component {
    render() {
      return(
        <Switch>
          <Route path="/showThankYou" render={(props) => <FlexLayout><ShowThankYou {...props}/></FlexLayout>}/>
          <Route path="/team" render={() => <FlexLayout><Team/></FlexLayout>}/>
          <Route path="/signin" render={() => <FlexLayout><SignIn/></FlexLayout>}/>
          <Route path="/reset-password" render={() => <FlexLayout><ResetPassword/></FlexLayout>}/>
          <Route path="/create-password" render={() => <FlexLayout><ResetPassword/></FlexLayout>}/>
          <Route path="/privacy" render={() => <FlexLayout><Privacy/></FlexLayout>}/>
          <Route path="/contact-us" render={() => <FlexLayout><ContactUs/></FlexLayout>}/>
          <Route path="/affiliate" render={() => <FlexLayout><Affiliate/></FlexLayout>}/>
          <Route path="/terms-of-use" render={() => <FlexLayout><TermsOfUse/></FlexLayout>}/>
          <Route exact path="/" render={(props) => <FlexLayout><Home {...props}/></FlexLayout>}/>
          <Route path="/storeonboarding" render={() => <FixedLayout><Storeonboarding/></FixedLayout>}/>

          <Route path="/startonboarding" render={() => <FixedLayout> <WelcomePage></WelcomePage> </FixedLayout>}/>
          <Route path="/onboarding" render={() => <FixedLayout><OnboardingView/></FixedLayout>}/>
          <Route path="/survey-result" render={() => <FlexLayout><SurveyResultNew/></FlexLayout>}/>
          <Route path="/plan" render={(props) => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><PlanView {...props}/></StripeProvider> </FlexLayout>}/>
          {/* <Route path="/recommendation-landing" render={(props) => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><GateFeeAA {...props}/></StripeProvider></FlexLayout>}/> */}
          {/* <Route path="/recommendation-landing-thank" render={(props) => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><GateFeeAA {...props}/></StripeProvider></FlexLayout>}/> */}

          <Route path="/recommendation-landing" render={(props) => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><GateFeeBoarding {...props}/></StripeProvider></FlexLayout>}/>
          <Route path="/recommendation-landing-thank" render={(props) => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><GateFeeBoarding {...props}/></StripeProvider></FlexLayout>}/>

          <Route exact path="/recommendations" render={() =>{
            if (localStorage.getItem("user_id")) {
              return <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><Recommendations/></StripeProvider></FlexLayout>
            }else{
              // 用户通过URL访问 recommendations , 因为没登录所有跳转到 登录页面。再登录要跳转到 recommendations view
              localStorage.setItem('url_visited_recommendations', true);
              window.location.pathname = 'signin'
            }
          }}/>
          <Route path="/recommendations/products/:id" render={(props) => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><ProductDetail {...props}/></StripeProvider></FlexLayout>}/>
          <Route path="/price-matching" render={() => <FlexLayout><PriceMatching/></FlexLayout>}/>
          <Route path="/return-policy" render={() => <FlexLayout><ReturnPolicy/></FlexLayout>}/>
          <Route path="/account" render={() => <FlexLayout><Account/></FlexLayout>}/>
          <Route path="/our-story" render={() => <FlexLayout><OurStory/></FlexLayout>}/>
          <Route path="/wishlist" render={() => <FlexLayout><Wishlist/></FlexLayout>} />
          <Route path="/reviewed-products" render={() => <FlexLayout><ReviewedProducts/></FlexLayout>} />
          <Route path="/referral" render={() => <FlexLayout><Referral/></FlexLayout>}/>
          <Route exact path="/gift" render={() => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><Gift/></StripeProvider></FlexLayout>}/>
          <Route exact path="/gift/thank-you" render={() => <FlexLayout><GiftThankYou/></FlexLayout>}/>
          <Route path="/orders" render={() => <FlexLayout><StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}><Orders/></StripeProvider></FlexLayout>}/>
          <Route exact path="/portal" render={() => <FlexLayout><CustomerPortalPassword/></FlexLayout>}/>
          <Route exact path="/portal/customer-tool" render={() => <FlexLayout><CustomerEmail/></FlexLayout>}/>
          <Route path="/portal/customer-tool/user-info" render={() => <FlexLayout><CustomerInfoAndProducts/></FlexLayout>}/>

          <Route exact path="/ath/onboarding" component={() => {
              window.location.href = 'https://www.allthingshair.com/en-us/';
              return null;
          }}/>

          <Route exact path="/ath/profile" render={() => <AthLayoutFlex><AthHairProfile/></AthLayoutFlex>}/>
          <Route exact path="/ath/recommendations" render={() => <AthLayoutFlex><AthRecommendations/></AthLayoutFlex>} />
          <Route exact path="/ath/login" render={() => <AthLayoutFlex><AthLogin/></AthLayoutFlex>}/>
          <Route path="/ath/reset-password" render={() => <AthLayoutFlex><AthReset/></AthLayoutFlex>}/>
          <Route path="/hair/landing" render={() => <FlexLayout><HairBuffer/></FlexLayout>}/>
          <Route path="/hair/onboarding" render={() => <FixedLayout><HairOnboarding/></FixedLayout>}/>
          <Route path="/hair/profile" render={() => <FlexLayout><HairProfile/></FlexLayout>}/>
          <Route path="/hair/recommendations" render={() => <FlexLayout><HairRecommendations/></FlexLayout>}/>
          <Route path="/Blog" render={() => <FlexLayout><Blog/></FlexLayout>}/>
          <Route path="/BlogDetail/:blogId/:articlesId" render={() => <FlexLayout><BlogDetail/></FlexLayout>}/>
          <Route path="*" render={() => <FlexLayout><NotFound/></FlexLayout>}/>
        </Switch>
      );
    }
  }



// WEBPACK FOOTER //
// ./src/App.js